import { render, staticRenderFns } from "./CourseComments.vue?vue&type=template&id=20a60655&"
import script from "./CourseComments.vue?vue&type=script&lang=js&"
export * from "./CourseComments.vue?vue&type=script&lang=js&"
import style0 from "./CourseComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports